import { render, staticRenderFns } from "./DisqualificationApply.vue?vue&type=template&id=0d012d88&scoped=true"
import script from "./DisqualificationApply.vue?vue&type=script&lang=js"
export * from "./DisqualificationApply.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationApply.vue?vue&type=style&index=0&id=0d012d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d012d88",
  null
  
)

export default component.exports